import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  border: 1px solid ', ';\n  border-right: none !important;\n  color: ', ';\n  cursor: pointer;\n  display: flex;\n  flex: 0 0 75px;\n  justify-content: center;\n  line-height: 1;\n  min-width: auto;\n  text-align: center;\n  text-transform: capitalize;\n  transition: all 0.2s ease;\n  @media (max-width: ', ') {\n    display: none;\n  }\n\n  ', '\n\n\n  ', '\n\n  ', '\n\n'], ['\n  align-items: center;\n  border: 1px solid ', ';\n  border-right: none !important;\n  color: ', ';\n  cursor: pointer;\n  display: flex;\n  flex: 0 0 75px;\n  justify-content: center;\n  line-height: 1;\n  min-width: auto;\n  text-align: center;\n  text-transform: capitalize;\n  transition: all 0.2s ease;\n  @media (max-width: ', ') {\n    display: none;\n  }\n\n  ', '\n\n\n  ', '\n\n  ', '\n\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      background-image: ', ';\n      background-size: cover;\n      color: ', ';\n    '], ['\n      background-image: ', ';\n      background-size: cover;\n      color: ', ';\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      border: 1px solid ', ';\n    '], ['\n      border: 1px solid ', ';\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      background-image: ', ';\n    '], ['\n      background-image: ', ';\n    ']);

import styled, { css } from 'styled-components';

export var StyledDiv = styled.div(_templateObject, function (props) {
  return props.theme.dormifyPink;
}, function (props) {
  return props.theme.dormifyBlack;
}, function (props) {
  return props.theme.tabletWidth;
}, function (_ref) {
  var dropdownActive = _ref.dropdownActive,
      theme = _ref.theme;
  return dropdownActive && css(_templateObject2, theme.dormifyPinkButtonNoHover, theme.dormifyWhite);
}, function (_ref2) {
  var btnDisabled = _ref2.btnDisabled,
      theme = _ref2.theme;
  return btnDisabled && css(_templateObject3, theme.dormifyLightGrey);
}, function (_ref3) {
  var btnDisabled = _ref3.btnDisabled,
      dropdownActive = _ref3.dropdownActive,
      theme = _ref3.theme;
  return btnDisabled && dropdownActive && css(_templateObject4, theme.dormifyGreyButtonNoHover);
});